<child-header [title]="'Confirm Renewal'" (closeEvent)="onNoClick()"></child-header>

<mat-spinner *ngIf="loading" mode="indeterminate" class="circle cSPCustomerEntitlements-loading" diameter="20" style="margin: 100px auto;"></mat-spinner>

<div *ngIf="!loading" mat-dialog-content>
  <br>
  <div style="height: 125px;">
    <table style="margin: auto;">
      <tr>
        <td>
          Ongoing charges from next term
        </td>
        <td style="text-align: right;">
          <span class="color-red bold"> {{ newTermAmount |
            currency:'AUD':'symbol-narrow':'.2-2'}}</span>
        </td>
      </tr>
    </table>
  </div>
  <div style="margin: 10px auto; text-align: center;">
    <p>Are you sure to upgrade on renewal ?</p>
  </div>
  <div style="text-align: center;">
    <button mat-button class="button button-red button-large nce-large-button continue" (click)="scheduleOnRenewal()">Schedule on Renewal</button>
  </div>
</div>
